import { defaults } from "lodash-es";
import React, { FC } from "react";

import { Card, Stack, SxProps } from "@mui/material";

import NewBadge from "./NewBadge";
import Link from "./styled/Link";

type VersionGuardProps = React.PropsWithChildren<{
  docsPath: string;
  helpText: string;
  minVersionRequired: string;
  enabled: boolean;
  sx?: SxProps;
}>;
const VersionGuard: FC<VersionGuardProps> = ({
  children,
  docsPath,
  helpText,
  minVersionRequired,
  enabled,
  sx,
}) => {
  return enabled ? (
    <>{children}</>
  ) : (
    <Stack
      sx={defaults(sx || {}, { width: "100%" })}
      justifyContent="space-around"
    >
      <Card
        sx={{
          p: 2,
          mx: "auto",
          maxWidth: "48em",
          textAlign: "center",
        }}
      >
        <NewBadge /> {helpText} Update your installation to version{" "}
        {minVersionRequired} or later to enable this feature.{" "}
        <Link to={`https://pomerium.com/docs${docsPath}`} target="_blank">
          Learn More
        </Link>
      </Card>
    </Stack>
  );
};
export default VersionGuard;
